class DiaSemanaEnum {
  constructor() {
    this.DOMINGO = 1;
    this.SEGUNDA = 2;
    this.TERCA = 3;
    this.QUARTA = 4;
    this.QUINTA = 5;
    this.SEXTA = 6;
    this.SABADO = 7;
  }
}

export default new DiaSemanaEnum();
